// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.5 5.5L14.5 5.5L14.5 1.5M14 5.5C13.02 3.15 10.7 1.5 8 1.5C4.41 1.5 1.5 4.41 1.5 8C1.5 11.59 4.41 14.5 8 14.5C10.89 14.5 13.34 12.61 14.19 10',
];
